export default __webpack_public_path__ + "static/media/flag-canary-islands.9a1add7f.svg";